import axios from "axios";

export default () => {
  const unauthorized = 401;

  const axiosInstance = axios.create({
    baseURL: window.apiBaseUrl,
    withCredentials: true
  });

  axiosInstance.interceptors.response.use(
    response => response,
    function(error) {
      // If the response has a 401, redirect to the login service
      if (
        typeof error.response !== "undefined" &&
        error.response.status == unauthorized
      ) {
        if (window.location.pathname != "/login") {
          window.location.replace("/login");
        }
        return;
      }

      return Promise.reject(error);
    }
  );

  return axiosInstance;
};
